/**
 * Authentication utility functions
 */

/**
 * Check if the user is authenticated
 * @returns {boolean} True if the user is authenticated
 */
export const isAuthenticated = () => {
  // Check if token exists in localStorage
  const token = localStorage.getItem('token');
  return !!token;
};

/**
 * Get the authentication token
 * @returns {string|null} The authentication token or null if not authenticated
 */
export const getToken = () => {
  return localStorage.getItem('token');
};

/**
 * Set the authentication token
 * @param {string} token - The authentication token
 */
export const setToken = (token) => {
  localStorage.setItem('token', token);
};

/**
 * Remove the authentication token
 */
export const removeToken = () => {
  localStorage.removeItem('token');
};

/**
 * Get the user data from Redux store
 * @param {Object} state - The Redux state
 * @returns {Object|null} The user data or null if not authenticated
 */
export const getUserData = (state) => {
  return state.user?.userData || null;
}; 